/**
 * BACK is hidden on Home (nowhere to go) and on the submit screen: once an
 * inspection is submitted, navigating "back" into its capture screens bypasses
 * the sanctioned EDIT flow (inspectionRecordService.reopen) and lands on a completed, synced
 * inspection. From the submit screen the intentional exits are EDIT and HOME.
 *
 * Lives outside Header.tsx so it is testable under bun - Header's import graph
 * includes the Vite-only 'virtual:pwa-register' (via usePWAStatus).
 */
export const shouldHideBack = (pathname: string): boolean =>
  pathname === '/' || pathname.endsWith('/submit');
